function importAll(r) {
    return r.keys().map(r);
  }
  
  const Greece_H = importAll(require.context('../assets/photos/Greece_H', false, /\.(png|jpe?g|svg)$/));
    
  export default Greece_H;